import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { IconButton } from "@mui/material" // Import Grid from MUI
import dayjs from "dayjs"
import React from "react"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { CustomButton } from "../GlobalComponents/CommonComponents"
import { FormField } from "../GlobalComponents/Fields"
import "./index.css"

export function DateCustomToolbar({
  label,
  onNavigate,
  onToday,
  currentDate,
  setCurrentDate,
  currentView,
  handleView,
}) {
  function handleChange(newDate) {
    if (newDate && newDate.isValid()) {
      setCurrentDate(newDate.toDate())
    } else {
      console.log("Invalid date")
    }
  }

  return (
    <div className="custom-toolbar-container">
      <div className="center-container">
        <CustomButton
          text="Today"
          onClick={onToday}
          sx={{
            backgroundColor: "#fff",
            color: "#2076e5",
            border: "1px solid #2076e5",
            shadow: "none",
          }}
        />

        <IconButton
          className="icon-styles"
          onClick={() => onNavigate("PREV")}
          sx={{ color: "inherit" }}
        >
          <ChevronLeftIcon sx={{ width: "40px", height: "40px" }} />
        </IconButton>

        <FormField
          type="date"
          // label="Date of Birth"
          name="dateOfBirth1"
          value={dayjs(currentDate)}
          onChange={handleChange}
        />

        <IconButton
          className="icon-styles"
          onClick={() => onNavigate("NEXT")}
          sx={{ color: "inherit" }}
        >
          <ChevronRightIcon sx={{ width: "40px", height: "40px" }} />
        </IconButton>
      </div>
    </div>
  )
}

export default DateCustomToolbar
